__turbopack_context__.v({
  "grid": "page-module-scss-module__djezWG__grid",
  "intro": "page-module-scss-module__djezWG__intro",
  "shop": "page-module-scss-module__djezWG__shop",
  "subtitle": "page-module-scss-module__djezWG__subtitle",
  "title": "page-module-scss-module__djezWG__title",
});
